import { ReactNode } from 'react';

import styles from './slideList.module.scss';

type Props<T> = {
  list: T[];
  activeIndex: number;
  children: (element: T, index: number, parentList: T[]) => ReactNode;
  listStyles?: string;
  cardStyles?: string;
};

export const SlideList = <T extends object>({
  list,
  children,
  activeIndex,
  listStyles = '',
  cardStyles = '',
}: Props<T>) => {
  return (
    <ul className={`${styles.list} ${listStyles}`}>
      {list.map((element, index, parentList) => {
        const isActive = index === activeIndex;

        return (
          <li
            key={index}
            className={`${styles.card} ${isActive ? styles.visible : styles.hidden} ${cardStyles}`}
          >
            {children(element, index, parentList)}
          </li>
        );
      })}
    </ul>
  );
};
